// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3oJBm","question":"Question_question__3n64i","description":"Question_description__1B048"};